import React, { useEffect } from "react";
const PIXEL_ID = "1185012390581364";
const SCRIPT_ID = "meta-pixel-base-code";

// Meta Pixel Code (official snippet)
const PIXEL_SNIPPET = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.innerHTML = PIXEL_SNIPPET;
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-46" data-mp="rk7eunrsewfv">
      <img height="1" width="1" style={{
      display: "none"
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-47" data-mp="rl0fr842erq3" />
    </noscript>;
}